import { Characteristics, Specifications } from "@/@types";

type Props = {
  characteristics: Characteristics;
  unitType: "metric" | "english";
  productName: string;
};

export default function ProductsListCharacteristicsCard({ characteristics, unitType, productName }: Props) {

  return (
    <>
      <h3 className=" text-xl font-bold mb-2 text-dark01">{productName}</h3>
      {
        (!characteristics || characteristics.metric.length < 1 || characteristics.english.length < 1) ? (
          <p className="text-sm text-gray-800">
            Sin métricas
          </p>
        ) : (
          <div>
            {(unitType === "metric" ? characteristics.metric : characteristics.english).map((metric: Specifications, index: number) => (
              <div key={index} className="flex justify-between items-end text-dark01 space-y-1">
                <p className="text-sm truncate max-w-[70%]" title={metric.rubro_specification.name}>
                  {metric.rubro_specification.name}
                </p>
                <p className="text-sm font-semibold truncate max-w-[30%]">
                  {metric.value} {metric.unit}
                </p>
              </div>
            ))}
          </div>
        )
      }
    </>
  );
}
